import React from "react";
import LanguageButton from "./LanguageButton";

export const Navigation = (props) => {
  const closeNav = () => {
    const navMenu = document.getElementById("bs-example-navbar-collapse-1");
    if (navMenu && navMenu.classList.contains("in")) {
      navMenu.classList.remove("in");
    }
  };

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          
          <a className="navbar-brand page-scroll notranslate goog-te-no-trans" href="#features">
            <img src='/img/logo.png' alt='Logo' style={{maxHeight: '24px', marginRight: '8px'}}/>
            The One
          </a>{" "}

          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >{" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>

        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#about" className="page-scroll" onClick={closeNav}>
                About
              </a>
            </li>
            <li>
              <a href="#services" className="page-scroll" onClick={closeNav}>
                Services
              </a>
            </li>
            {/* <li>
              <a href="#gallery" className="page-scroll notranslate goog-te-no-trans" onClick={closeNav}>
                Gallery
              </a>
            </li> */}
            <li>
              <a href="#testimonials" className="page-scroll" onClick={closeNav}>
                Testimonials
              </a>
            </li>
            <li>
              <a href="#team" className="page-scroll" onClick={closeNav}>
                Team
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll notranslate goog-te-no-trans" onClick={closeNav}>
                Contact
              </a>
            </li>
            <li>
              <LanguageButton />
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
